// extracted by mini-css-extract-plugin
export default {"cancellation":"CancellationPolicy_cancellation__6vL-v","cancellation__content":"CancellationPolicy_cancellation__content__SEQHs"};